<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="cp5" fxLayout="row wrap" fxLayoutAlign="flex-start center">
        <div fxFlex="100" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('chfNm')"
                    [label]="'Nom et prénom'"
                    [lettre]="true"
            ></app-text-field>
        </div>

        <div *ngIf="data == 'TUN'" fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('indRegNo')"
                    [label]="setlable()"
                    [number]="data == 'TUN'"
                    [max]="8"
            ></app-text-field>
        </div>

        <div *ngIf="data != 'TUN'"  fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('indRegNo')"
                    [label]="setlable()"
                    
            ></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-select-date [control]="get('issuedYmd')" [label]="'Date de délivrance'" [max]="currentDate">

            </app-select-date>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('mtelNo')"
                    [label]="'tel_port'"
                    [numberphone]="true"
            ></app-text-field>
        </div>


        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('email')"
                    [label]="'Email du premier responsable'"
            ></app-text-field>
        </div>
    </div>
    <div fxLayoutAlign="end end" mat-dialog-actions>
        <app-spinner-container>
            <button color="primary" mat-raised-button>
                <span translate>submit</span>
            </button>
        </app-spinner-container>
    </div>
</form>
